import { render, staticRenderFns } from "./applyAssign.vue?vue&type=template&id=0a42aba4&scoped=true&"
import script from "./applyAssign.vue?vue&type=script&lang=js&"
export * from "./applyAssign.vue?vue&type=script&lang=js&"
import style0 from "./applyAssign.vue?vue&type=style&index=0&id=0a42aba4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a42aba4",
  null
  
)

export default component.exports